<template>
  <div id="AnnouncementDetails">
    <el-breadcrumb separator="/" >
      <el-breadcrumb-item>渠道政策</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/Announcements/newAnnouncement' }">通知公告</el-breadcrumb-item>
      <el-breadcrumb-item>公告详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="page"
      v-loading="actLoading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading">
      <el-row class="elrowStyle">
        <el-col :span="20" style="padding-left: 40px;font-size: 18px;font-weight: bold;white-space:normal;margin-bottom: 16px;">
          {{notice_title}}
        </el-col>
        <el-col :span="4" style="text-align: right;padding-right: 40px;">
          <el-popover
            placement="bottom"
            width="320"
            trigger="click"
            v-model="visible"
            >
            <div>
              <el-tabs v-model="activeName" style="margin-top: -10px;">
                <el-tab-pane :label="totalDealers" name="first">
                  <div style="max-height: 240px;overflow-y: auto;">
                    <div v-for="item in dealist" style="margin-bottom: 10px;">{{item.dealername}}</div>
                  </div>
                </el-tab-pane>
                <el-tab-pane :label="totalShop" name="second">
                  <div style="max-height: 240px;overflow-y: auto;">
                    <div v-for="item in shoplist" style="margin-bottom: 10px;">
                      <div style="float: left;margin-top: -3px;margin-right: 5px;">{{item.shopName}}</div>
                      <img :src='require("@/assets/img/platform/pla_"+item.platformCode+".png")' alt style="width: 15px;height: 15px;">
                    </div>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
            <el-button type="text" @click="Detailread" slot="reference" v-show="type.logintype == 'HCM'  || type.roleid == '23' || type.logintype == 'HCMSUB'">未读人员</el-button>
            <!-- <span
              @click="Detailread"
              slot="reference"
              style="color: #999999;"
              v-show="type.logintype == 'HCM'  || type.roleid == '23' || type.logintype == 'HCMSUB'">
              未读人员
            </span> -->
          </el-popover>


        </el-col>
      </el-row>

      <div style="display: flex;margin-left: 40px;margin-top: 15px;">
        <div class="textType">
          {{notice_typename}}<span>|</span>
        </div>
        <div class="textType">
          {{createtime | formatDate}}<span>|</span>
        </div>
        <div class="textType">
          From：{{user_name}}
        </div>

        <div class="toStyle" v-show="type.logintype == 'HCMSUB' || type.logintype == 'HCM' ">
          <span v-if="noticeShopsList">
            <span v-if="noticeShopsList.length > 0 ">
              To店铺：
            </span>
          </span>
          <span v-for="item in noticeShopsList" v-if="noticeShopsList.length != 0">{{item.shop_name}}、</span>
          <span v-if="noticeDepartsList">
            <span v-if="noticeDepartsList.length > 0 ">
              To部门：
            </span>
          </span>
          <span v-for="item in noticeDepartsList">{{item.depart_name}}</span>
          <span v-if="noticeClassifysList">
            <span v-show="noticeClassifysList.length > 0 ">
              To品类：
            </span>
          </span>
          <span v-for="item in noticeClassifysList" v-if="item.product_classify_name">
            {{item.product_classify_name}}
            <span v-show="noticeClassifysList.length > 1">
              、
            </span>
          </span>
        </div>
      </div>



      <div class="htmlStyle" v-html="notice_content" v-show="!/.*[\u4e00-\u9fa5]+.*$/.test(notice_content)">
      </div>

      <div style="margin-left: 40px;margin-top: 40px;margin-right: 30%;width: 80%" v-html="notice_content" v-show="/.*[\u4e00-\u9fa5]+.*$/.test(notice_content)">
      </div>

      <div class="accessoriesClause" v-if="attach_urls && attach_urls != ''">
        <div style="font-weight: bold;float: left;">
          <span style="margin-left: 5px;font-size: 16px;">附件</span>
        </div>
        <div style="color: #999999;float: right;">
          <span style="margin-left: 5px;font-size: 14px;">共{{attach_urls.length}}个附件</span>
        </div>
      </div>

      <div class="attachmentBox" v-for="item in attach_urls">
        <div class="cardFont">
          <i class="el-icon-document" style="font-size: 25px;margin-right: 10px;line-height: 40px;float: left;"></i>{{item.name}}
        </div>
        <el-button @click="downloadFormat(item.url)" type="text" style="float: right;margin-left: 10px;">下载</el-button>
        <el-button @click="preView(item.url)" type="text" style="float: right;">预览</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import aes from "../../libs/aes";
  export default {
    data() {
      return {
        totalDealers: '',
        totalShop: '',
        activeName: 'first',
        actLoading: true,
        notice_title: '',
        notice_typename: '',
        createtime: '',
        user_name: '',
        noticeDepartsList: [],
        noticeClassifysList: [],
        noticeShopsList: [],
        notice_content: '',
        notice_send_type: '',
        attach_urls: [],
        dealist: [],
        shoplist: [],
        visible: false,
        type: '',
      }
    },
    filters: {
      formatDate: function (value) {
        let date = new Date(value);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? ('0' + MM) : MM;
        let d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        let h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        let m = date.getMinutes();
        m = m < 10 ? ('0' + m) : m;
        let s = date.getSeconds();
        s = s < 10 ? ('0' + s) : s;
        return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
      }
    },
    created(){
  	},
    mounted() {
      this.theQuery();
      this.type = JSON.parse(window.localStorage.userData)
      console.log(this.type.logintype)
    },

    methods: {
      // 预览
      preView(item){
  			if(item.indexOf('.pdf')!=-1){
  				let url = '/hcm/wechat/downLoadFilephone?filename=' + item;
  				window.open(url);
  			} else if (item.indexOf('.doc')!=-1 || item.indexOf('.docx')!=-1 || item.indexOf('.xls')!=-1 ||item.indexOf('.xlsx')!=-1){
  				window.open('https://view.officeapps.live.com/op/view.aspx?src=https://hawksights.obs.cn-east-2.myhuaweicloud.com/'+item)
  			} else if (item.indexOf('.png')!=-1) {
          window.open('https://hawksights.obs.cn-east-2.myhuaweicloud.com/'+item)
        }
  		},
      Detailread() {
        let params={
          notice_id: this.$route.query.e,
          bmcid: '',
        }
        fetch({
          url: "hcm/notice/Detailread",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            if (data.shoplist || data.dealist) {
              this.notice_send_type = data.shoplist.length + data.dealist.length
            } else {
              this.notice_send_type = 0
            }

            if (data.dealist) {
              this.dealist = data.dealist;
            }
            if (data.shoplist) {
              this.shoplist = data.shoplist;
            }
            this.totalDealers = '经销商(' + this.dealist.length + ')'
            this.totalShop = '店铺(' + this.shoplist.length + ')'
          }
        }).catch(err => {
          this.$message.error('接口异常');
        });
      },
      // 数据获取
      theQuery() {
        let params={
          notice_id: this.$route.query.e,
          bmcid: '',
        }
        fetch({
          url: "hcm/notice/Detail",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.actLoading = false
            this.notice_title = data.notice_title;
            this.notice_typename = data.notice_typename;
            this.createtime = data.createtime;
            this.user_name = data.user_name;
            this.noticeDepartsList = data.noticeDepartsList;
            this.noticeShopsList = data.noticeShopsList;
            this.noticeClassifysList = data.noticeClassifysList;
            this.notice_content = data.notice_content;
            this.attach_urls = JSON.parse(data.attach_urls);
          }
        }).catch(err => {
          this.$message.error('接口异常');
        });
      },
      downloadFormat(e) {
        console.log(e)
        window.open('/hcm/hcmWorkOrder/downLoadFile?filename=' + e, '_blank'); // 新开窗口
      },
    }
  }
</script>
<style scoped lang="scss">
  .header {
    width: 100%;
    height: 40px;
    background-color: white;
  }
  .page {
    padding: 20px;
    margin: 20px;
    background-color: white;
  }
  .headerSize {
    line-height: 40px;
    text-align: right;
  }
  .addFont {
    color: #747474;
    font-weight: bold;
    text-align: center;
    border: 1px dashed #e8ebec;
    height: 30px;
    line-height: 30px;
    cursor: pointer;
  }
  .block {
    text-align: right;
    margin-top: 20px;
  }
  .cardFont {
    font-size: 14px;
    float: left;
    line-height: 40px;
  }
  .attachmentBox {
    margin-left: 36px;
    width: 80%;
    padding: 10px 20px;
    height: 40px;
  }
  .attachmentBox:hover {
    border: 1px solid #66b1ff;
    color: #66b1ff;
    border-radius: 5px;
  }
  .htmlStyle {
    margin-left: 40px;
    margin-top: 40px;
    margin-right: 30%;
    width: 80%;
    overflow-x:auto;
    white-space:nowrap;
  }
  .accessoriesClause {
    margin: 40px 40px 20px 40px;
    height: 55px;
    line-height: 55px;
    border-bottom: 1px solid #e8ebec;
  }
  .unreadStyle {
    height: 40px;
    font-size: 16px;
    font-weight: bold;
    line-height: 30px;
    border-bottom: 1px solid #e8ebec;
    padding-left: 20px;
  }
  .toStyle {
    margin-left: 40px;
    height: 15px;
    line-height: 15px;
    color: #a1a1a1;
  }
  .elrowStyle {

    border-bottom: 1px solid #e8ebec;

  }

</style>
<style lang="scss">
#AnnouncementDetails {
  .textType {
    margin-right: 20px;
    height: 15px;
    line-height: 15px;
    color: #a1a1a1;
    span {
      margin-left: 20px;
      font-weight: 100;
    }
  }
  .el-table th {
    background-color: #f3f7ff !important;
  }
  #dialog {
    .el-dialog__header {
      padding: 20px 20px 10px;
      border-bottom: 1px solid #d9d9d9;
    }
  }
  .el-button+.el-button {
    margin-left: 1px;
  }
  .el-card {
    border: none;
    background-color: #FFF;
    color: #303133;
    -webkit-transition: .3s;
    transition: .3s;
  }
}
</style>
